module.exports = __webpack_public_path__ + "img/honor4.1c51b12b.jpg";